import {
  LOAD_GROUPS,
  LOAD_GROUPS_SUCCESS,
  LOAD_GROUPS_FAIL,
} from "./actionTypes";
import { AsyncAction } from "../../store";

export function loadGroups(
  user: Insite.AppState["auth"]["user"],
  form = null
): AsyncAction {
  return {
    types: [LOAD_GROUPS, LOAD_GROUPS_SUCCESS, LOAD_GROUPS_FAIL],
    promise: (client) =>
      client.get("groups/lookup", {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        params: {
          form,
        },
      }),
  };
}
